<template>
  <kst-table action input-mode :data="userAddressList">
    <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
      <template #header>
        <kst-header-blank />
      </template>
      <template #default="{ row }">
        <kst-tooltip v-if="row.Errors.length > 0" error-mode>
          <template #content>
            <kst-list :items="row.Errors"/>
          </template>
          <kst-icon error-mode/>
        </kst-tooltip>
      </template>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kstmod-vendor-new-Name"
      field="Name"
      :label="VendorAddressCatalog.Name.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="VendorAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kstmod-vendor-new-Address"
      field="Address"
      :label="VendorAddressCatalog.Address.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="VendorAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kstmod-vendor-new-ContactName"
      field="ContactName"
      :label="VendorAddressCatalog.ContactName.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="VendorAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kstmod-vendor-new-ContactMobile"
      field="ContactMobile"
      :label="VendorAddressCatalog.ContactMobile.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="VendorAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kstmod-vendor-new-ContactPhone"
      field="ContactPhone"
      :label="VendorAddressCatalog.ContactPhone.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="VendorAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="kstmod-vendor-new-ContactEmail"
      field="ContactEmail"
      :label="VendorAddressCatalog.ContactEmail.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="VendorAddressCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <template #action="{ index }">
      <kst-tooltip delete-mode hover-only :content="Model.VendorAddress.Module.FullName">
        <kst-button delete-mode is-round @click="handleRowDelete(index)"/>
      </kst-tooltip>
    </template>

    <template #empty-body>
      <ValidationProvider v-slot="{ errors }" name="userAddressList" rules="required">
        <kst-error :array-blank-mode="!!errors"/>
      </ValidationProvider>
    </template>
  </kst-table>
</template>

<script>
import DialogMixin from "../../../mixins/DialogMixin.js";
import Info from "../VenInfo.js";
import Model from "../VenModel.js";
import VendorAddressCatalog from "../VenaCatalog.js";

export default {
  mixins: [DialogMixin],
  props: {
    userAddressList: Array
  },
  data: () => ({
    Model: Model,
    VendorAddressCatalog: VendorAddressCatalog
  }),
  methods: {
    handleRowDelete(index) {
      this.showConfirm(
        Info.Message.New_ConfirmDeleteAddress,
        this.handleRowDelete_confirm,
        null,
        index
      );
    },
    handleRowDelete_confirm(index) {
      this.userAddressList.splice(index, 1);
    },

    handleRowErrors(errors, field, index) {
      Model.setAddressErrors(this.userAddressList[index], field, errors);
    }
  }
}
</script>